import GridModuleContentCard from './GridModuleContentCard';
import GridModuleTitleV4 from './GridModuleTitleV4';
import BigOverContentCardV4 from '../../../common/component/BigOverContentCardV4';
import ContentCardWrapperV4 from '../../../common/component/ContentCardWrapperV4';
import styles from '../../../common/scss/wrapper.module.scss';
import {
  IBigOverContent,
  IMainContentHandler,
  IMainItem,
  IMainParams,
} from '../type';

interface IProps {
  item: IMainItem;
  className?: string;
  marginTop?: string;
  showAllContents?: boolean;
  hideTitle?: boolean;
  onClickBigContent?: IMainContentHandler<IBigOverContent>;
  onClickContent?: IMainContentHandler;
  onSendViewImpBigContent?: IMainContentHandler<IBigOverContent>;
  onSendViewImpContent?: IMainContentHandler;
  onClickPromotionVideo?: IMainContentHandler<IBigOverContent>;
  onClickPromotionVideoMute?: (
    isMute: boolean,
    params: Omit<IMainParams, 'item'>
  ) => void;
  onClickPromotionVideoPlay?: IMainContentHandler<IBigOverContent>;
}

export default function GridModule({
  item,
  className,
  marginTop,
  showAllContents,
  hideTitle,
  onClickBigContent,
  onClickContent,
  onSendViewImpBigContent,
  onSendViewImpContent,
  onClickPromotionVideo,
  onClickPromotionVideoMute,
  onClickPromotionVideoPlay,
}: IProps) {
  const {
    title,
    bigContent,
    showRankingInfo,
    contents = [],
    isAdminSection,
  } = item;
  return (
    <div className={className} style={{marginTop}}>
      {title && !hideTitle && <GridModuleTitleV4 title={title} />}
      {bigContent && (
        <BigOverContentCardV4
          content={bigContent}
          showAuthors={bigContent.showAuthors}
          titleText={bigContent.titleText}
          blackBadgeList={bigContent.blackBadgeList}
          eventIpVideo={bigContent.eventIpVideo}
          rankingInfo={
            showRankingInfo
              ? {
                  ranking: bigContent.ranking,
                  delta: bigContent.delta,
                }
              : undefined
          }
          onClickContent={() =>
            onClickBigContent?.({content: bigContent, index: 0})
          }
          onSendViewImp={() =>
            onSendViewImpBigContent?.({content: bigContent, index: 0})
          }
          onClickPromotionVideo={() =>
            onClickPromotionVideo?.({content: bigContent, index: 0})
          }
          onClickPromotionVideoMute={isMute =>
            onClickPromotionVideoMute?.(isMute, {
              content: bigContent,
              index: 0,
            })
          }
          onClickPromotionVideoPlay={() =>
            onClickPromotionVideoPlay?.({content: bigContent, index: 0})
          }
        />
      )}
      {contents.length > 0 && (
        <ContentCardWrapperV4
          className={cn('mt-4', !showAllContents && styles.wrapper7)}
          showEmptyContentCard
        >
          {contents.map((content, index) => (
            <GridModuleContentCard
              key={index}
              index={index}
              content={content}
              showRankingInfo={showRankingInfo}
              onClickContent={() =>
                onClickContent?.({
                  content,
                  index: isAdminSection ? index : index + 1,
                })
              }
              onSendViewImpContent={() =>
                onSendViewImpContent?.({
                  content,
                  index: isAdminSection ? index : index + 1,
                })
              }
            />
          ))}
        </ContentCardWrapperV4>
      )}
    </div>
  );
}
